export default __webpack_public_path__ + "static/media/logo.1b008858.svg";